// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.profile-suggestions__container{
    background: var(--white-color);
    box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32);
    border-radius: 12px;
    margin-bottom: calc(var(--space-and-half) + var(--space-eighth));
    padding-top: var(--space-and-half);
}
.profile-suggestions__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    margin-left: var(--space-and-half);
    text-transform: capitalize;
}
/* .profile-suggestions__list{} */
.profile-suggestions__list__page-item{
    display: flex;
    margin-top: var(--space-and-half);
    margin-bottom: var(--space-and-half);
    margin-left: var(--space-and-half);
    margin-right: var(--space);
    justify-content: space-between;
}
.profile-suggestions__list__page-item .icon-ball{
    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));
    color: var(--white-color);
}

.profile-suggestions__list__page-item img{
    width: calc(var(--space-x2-and-half) - var(--space-eighth));
    height: calc(var(--space-x2-and-half) - var(--space-eighth));
    border-radius: 50%;
}
.profile-suggestions__list__page-item__data{
    margin-left: var(--space-half-quarter);
}
.profile-suggestions__list__page-item__data-name.baloa-names{
    color: var(--primary-dark-color);
}
.profile-suggestions__list__page-item__data-username.baloa-username{
    color: var(--basic-gray-color);
}
.profile-suggestions__list__page-item__data-name.baloa-names.baloa-truncate{
    width: 9vw;
}
.profile-suggestions__list__page-item__data-username.baloa-username.baloa-truncate{
    width: 9vw;
}
.profile-suggestions__add-link{
    padding-left: var(--space-and-half);
    padding-top: calc(var(--space) + var(--space-quarter));
    padding-bottom: calc(var(--space) + var(--space-quarter));
}
.profile-suggestions__add-link.baloa-names{
    color: var(--new-green-color);
    cursor: pointer;
}
.profile-suggestions__add-link.baloa-names::first-letter{
    text-transform: uppercase;
}

.profile-suggestions__add-link .icon-plus{
    font-size: var(--space);
    color: var(--basic-gray-color);
    cursor: pointer;
}
.profile-suggestions__separator{
    border-top: 1px solid var(--separator-color);
}
.profile-suggestions__menu-link{
    padding-top: calc(var(--space) - var(--space-eighth));
    padding-bottom: calc(var(--space) - var(--space-eighth));
}
.profile-suggestions__menu-link.baloa-hyperlink-2{
    text-align: center;
    color: var(--new-green-color);    
    cursor: pointer;
}

.profile-suggestions__menu-link.baloa-hyperlink-2::first-letter{
    text-transform: uppercase;
}



/* .profile-suggestions {}

.profile-suggestions__suggestion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 66.6%;
    margin: 0 auto;
    margin-bottom: var(--space-x2);
}
 */
.profile-suggestions__suggestion__profile-info {
    display: flex;
    align-items: center;
}

/* .profile-suggestions__suggestion__profile-info__photo {
    max-width: var(--space-x2-and-half);
    max-height: var(--space-x2-and-half);
    min-width: var(--space-x2-and-half);
    min-height: var(--space-x2-and-half);
    margin-right: var(--space-half);
    border-radius: 2px;
    overflow: hidden;
    position: relative;
    background: var(--primary-light-color);
}
.profile-suggestions__suggestion__profile-info__photo.no-photo {
    padding: var(--space-quarter);
}
.profile-suggestions__suggestion__profile-info__photo img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
}
.profile-suggestions__suggestion__profile-info__photo.no-photo img {
    position: relative;
}

.profile-suggestions__suggestion__profile-info__data {
    display: flex;
    flex-direction: column;
    margin-right: var(--space-half);
}

.profile-suggestions__suggestion__profile-info__data__fullname {
    font-family: var(--secondary-font) !important;
    font-weight: var(--font-regular);
    font-size: var(--space);
    line-height: var(--space-and-half);
    color: var(--primary-dark-color);
}

.profile-suggestions__suggestion__profile-info__data__username {
    font-family: var(--secondary-font) !important;
    font-weight: var(--font-regular);
    font-size: var(--space-half-and-quarter);
    line-height: var(--space);
    letter-spacing: 0.004em;
    color: var(--basic-gray-color);
} */
/* .profile-suggestions__suggestion__follow-button button{
    padding: calc( var(--space-quarter) / 2 ) !important;
} */

/* Small */
/*
.profile-suggestions.sm .profile-suggestions__suggestion {
    background-color: var(--white-color);
    flex-direction: column;
    padding: var(--space);
    border-radius: 4px;
    box-shadow: var(--shadow-card-1);
    width: 100%;
    margin-bottom: var(--space);
}
.profile-suggestions.sm .profile-suggestions__suggestion__profile-info {
    align-self: flex-start;
    align-items: flex-start;
}
.profile-suggestions.sm .profile-suggestions__suggestion__profile-info__photo {
    border-radius: 8px;
}
.profile-suggestions.sm .profile-suggestions__suggestion__profile-info__data__fullname {
    display: none;
}
.profile-suggestions.sm .profile-suggestions__suggestion__profile-info__data__username {
    font-size: var(--font-small);
    letter-spacing: 0.004em;
    font-weight: var(--font-bold) !important;
}
.profile-suggestions.sm .profile-suggestions__suggestion__follow-button {
    margin-top: var(--space-quarter);
    align-self: flex-end;
}
*/
/* Mobile */

.profile-suggestions.mv .profile-suggestions__suggestion {
    flex-direction: column;
    align-content: center;
}

.profile-suggestions.mv .profile-suggestions__suggestion__profile-info {
    flex-direction: column;
    align-self: auto;
    align-items: center;
}

.profile-suggestions.mv .profile-suggestions__suggestion__profile-info__photo {
    margin: 0;
}

.profile-suggestions.mv .profile-suggestions__suggestion__profile-info__data {
    margin: 0;
}

.profile-suggestions.mv .profile-suggestions__suggestion__follow-button {
    align-self: auto;
}


@media screen and ( max-width: 576px ) {
    
    .profile-suggestions__suggestion {
        width: 100%;
    }

}
`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-suggestions/ProfileSuggestionsComponent.styles.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,6DAA6D;IAC7D,mBAAmB;IACnB,gEAAgE;IAChE,kCAAkC;AACtC;AACA;IACI,qCAAqC;IACrC,kCAAkC;IAClC,0BAA0B;AAC9B;AACA,iCAAiC;AACjC;IACI,aAAa;IACb,iCAAiC;IACjC,oCAAoC;IACpC,kCAAkC;IAClC,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,4DAA4D,CAAC,OAAO;IACpE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yEAAyE;IACzE,yBAAyB;AAC7B;;AAEA;IACI,2DAA2D;IAC3D,4DAA4D;IAC5D,kBAAkB;AACtB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,mCAAmC;IACnC,sDAAsD;IACtD,yDAAyD;AAC7D;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,qDAAqD;IACrD,wDAAwD;AAC5D;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;;;;;;;;;;EAUE;AACF;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8CG;AACH;;GAEG;;AAEH,UAAU;AACV;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA6BC;AACD,WAAW;;AAEX;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;;IAEI;QACI,WAAW;IACf;;AAEJ","sourcesContent":["\n.profile-suggestions__container{\n    background: var(--white-color);\n    box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32);\n    border-radius: 12px;\n    margin-bottom: calc(var(--space-and-half) + var(--space-eighth));\n    padding-top: var(--space-and-half);\n}\n.profile-suggestions__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    margin-left: var(--space-and-half);\n    text-transform: capitalize;\n}\n/* .profile-suggestions__list{} */\n.profile-suggestions__list__page-item{\n    display: flex;\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space-and-half);\n    margin-left: var(--space-and-half);\n    margin-right: var(--space);\n    justify-content: space-between;\n}\n.profile-suggestions__list__page-item .icon-ball{\n    font-size: calc(var(--space-and-half) + var(--space-eighth));/*26px*/\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(6px * 2));\n    color: var(--white-color);\n}\n\n.profile-suggestions__list__page-item img{\n    width: calc(var(--space-x2-and-half) - var(--space-eighth));\n    height: calc(var(--space-x2-and-half) - var(--space-eighth));\n    border-radius: 50%;\n}\n.profile-suggestions__list__page-item__data{\n    margin-left: var(--space-half-quarter);\n}\n.profile-suggestions__list__page-item__data-name.baloa-names{\n    color: var(--primary-dark-color);\n}\n.profile-suggestions__list__page-item__data-username.baloa-username{\n    color: var(--basic-gray-color);\n}\n.profile-suggestions__list__page-item__data-name.baloa-names.baloa-truncate{\n    width: 9vw;\n}\n.profile-suggestions__list__page-item__data-username.baloa-username.baloa-truncate{\n    width: 9vw;\n}\n.profile-suggestions__add-link{\n    padding-left: var(--space-and-half);\n    padding-top: calc(var(--space) + var(--space-quarter));\n    padding-bottom: calc(var(--space) + var(--space-quarter));\n}\n.profile-suggestions__add-link.baloa-names{\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n.profile-suggestions__add-link.baloa-names::first-letter{\n    text-transform: uppercase;\n}\n\n.profile-suggestions__add-link .icon-plus{\n    font-size: var(--space);\n    color: var(--basic-gray-color);\n    cursor: pointer;\n}\n.profile-suggestions__separator{\n    border-top: 1px solid var(--separator-color);\n}\n.profile-suggestions__menu-link{\n    padding-top: calc(var(--space) - var(--space-eighth));\n    padding-bottom: calc(var(--space) - var(--space-eighth));\n}\n.profile-suggestions__menu-link.baloa-hyperlink-2{\n    text-align: center;\n    color: var(--new-green-color);    \n    cursor: pointer;\n}\n\n.profile-suggestions__menu-link.baloa-hyperlink-2::first-letter{\n    text-transform: uppercase;\n}\n\n\n\n/* .profile-suggestions {}\n\n.profile-suggestions__suggestion {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 66.6%;\n    margin: 0 auto;\n    margin-bottom: var(--space-x2);\n}\n */\n.profile-suggestions__suggestion__profile-info {\n    display: flex;\n    align-items: center;\n}\n\n/* .profile-suggestions__suggestion__profile-info__photo {\n    max-width: var(--space-x2-and-half);\n    max-height: var(--space-x2-and-half);\n    min-width: var(--space-x2-and-half);\n    min-height: var(--space-x2-and-half);\n    margin-right: var(--space-half);\n    border-radius: 2px;\n    overflow: hidden;\n    position: relative;\n    background: var(--primary-light-color);\n}\n.profile-suggestions__suggestion__profile-info__photo.no-photo {\n    padding: var(--space-quarter);\n}\n.profile-suggestions__suggestion__profile-info__photo img {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n}\n.profile-suggestions__suggestion__profile-info__photo.no-photo img {\n    position: relative;\n}\n\n.profile-suggestions__suggestion__profile-info__data {\n    display: flex;\n    flex-direction: column;\n    margin-right: var(--space-half);\n}\n\n.profile-suggestions__suggestion__profile-info__data__fullname {\n    font-family: var(--secondary-font) !important;\n    font-weight: var(--font-regular);\n    font-size: var(--space);\n    line-height: var(--space-and-half);\n    color: var(--primary-dark-color);\n}\n\n.profile-suggestions__suggestion__profile-info__data__username {\n    font-family: var(--secondary-font) !important;\n    font-weight: var(--font-regular);\n    font-size: var(--space-half-and-quarter);\n    line-height: var(--space);\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color);\n} */\n/* .profile-suggestions__suggestion__follow-button button{\n    padding: calc( var(--space-quarter) / 2 ) !important;\n} */\n\n/* Small */\n/*\n.profile-suggestions.sm .profile-suggestions__suggestion {\n    background-color: var(--white-color);\n    flex-direction: column;\n    padding: var(--space);\n    border-radius: 4px;\n    box-shadow: var(--shadow-card-1);\n    width: 100%;\n    margin-bottom: var(--space);\n}\n.profile-suggestions.sm .profile-suggestions__suggestion__profile-info {\n    align-self: flex-start;\n    align-items: flex-start;\n}\n.profile-suggestions.sm .profile-suggestions__suggestion__profile-info__photo {\n    border-radius: 8px;\n}\n.profile-suggestions.sm .profile-suggestions__suggestion__profile-info__data__fullname {\n    display: none;\n}\n.profile-suggestions.sm .profile-suggestions__suggestion__profile-info__data__username {\n    font-size: var(--font-small);\n    letter-spacing: 0.004em;\n    font-weight: var(--font-bold) !important;\n}\n.profile-suggestions.sm .profile-suggestions__suggestion__follow-button {\n    margin-top: var(--space-quarter);\n    align-self: flex-end;\n}\n*/\n/* Mobile */\n\n.profile-suggestions.mv .profile-suggestions__suggestion {\n    flex-direction: column;\n    align-content: center;\n}\n\n.profile-suggestions.mv .profile-suggestions__suggestion__profile-info {\n    flex-direction: column;\n    align-self: auto;\n    align-items: center;\n}\n\n.profile-suggestions.mv .profile-suggestions__suggestion__profile-info__photo {\n    margin: 0;\n}\n\n.profile-suggestions.mv .profile-suggestions__suggestion__profile-info__data {\n    margin: 0;\n}\n\n.profile-suggestions.mv .profile-suggestions__suggestion__follow-button {\n    align-self: auto;\n}\n\n\n@media screen and ( max-width: 576px ) {\n    \n    .profile-suggestions__suggestion {\n        width: 100%;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
